
(async()=>{
const root=document.querySelector('[data-tb-builder]'); if(!root)return; if(getComputedStyle(root).position==='static') root.style.position='relative';
const catalogueUrl=root.dataset.catalogueUrl;
const builderAssets=JSON.parse(root.querySelector('[data-builder-assets]')?.textContent||'{}');
const moneyFormat=root.dataset.moneyFormat||'£{{amount}}';
const rail=root.querySelector('#tb-bead-rail'), braceletImg=root.querySelector('#tb-bracelet-art'), claspImg=root.querySelector('#tb-clasp-art');
// Larger jewellery artwork: bracelet geometry remains untouched.
const sizeStyle=document.createElement('style');
sizeStyle.textContent=`
  /* Never allow Motion/theme image rules to expose an empty builder image. */
  .tb-builder #tb-bracelet-art[hidden],
  .tb-builder #tb-clasp-art[hidden]{
    display:none !important;
  }

  /* Larger bead artwork — not merely a larger invisible button box. */
  .tb-builder .tb-dragbead{
    height:215px !important;
    width:auto !important;
    min-width:84px !important;
    padding:0 !important;
    margin:0 !important;
    border:0 !important;
    outline:0 !important;
    background:transparent !important;
    box-shadow:none !important;
  }
  .tb-builder .tb-dragbead img{
    display:block !important;
    height:215px !important;
    width:auto !important;
    max-width:none !important;
    max-height:none !important;
    object-fit:contain !important;
    border:0 !important;
    outline:0 !important;
    box-shadow:none !important;
  }
  .tb-builder .tb-dragbead.is-selected,
  .tb-builder .tb-dragbead:focus,
  .tb-builder .tb-dragbead:focus-visible,
  .tb-builder .tb-dragbead.is-dragging{
    border:0 !important;
    outline:0 !important;
    box-shadow:none !important;
  }
  @media(max-width:900px){
    .tb-builder .tb-dragbead{height:96px !important;min-width:42px !important;}
    .tb-builder .tb-dragbead img{height:96px !important;}
  }
`;
document.head.appendChild(sizeStyle);
const $=s=>root.querySelector(s), $$=s=>[...root.querySelectorAll(s)];
let products=[];
try{const r=await fetch(catalogueUrl,{cache:'no-cache'}); products=(await r.json()).products||[]}catch(e){$('#tb-grid').innerHTML='<p>Catalogue could not be loaded.</p>';return}
let uid=0;
const state={step:'bracelet',bracelet:null,braceletVariant:null,clasp:null,beads:[],selected:null,query:'',filter:'all',sort:'featured',page:1,perPage:36,showDesign:false,drag:null};


/* ---------- Bracelet Builder Intelligence tracking ---------- */
const TB_BUILDER_TRACK_ENDPOINT='https://rewards-tier-calculator.onrender.com/apps/bracelet-builder-track';
const TB_BUILDER_SESSION_KEY='tb_builder_session_id_v1';
let tbBuilderSessionId=sessionStorage.getItem(TB_BUILDER_SESSION_KEY);
if(!tbBuilderSessionId){
 tbBuilderSessionId='tbbs_'+(crypto.randomUUID?crypto.randomUUID():Date.now()+'_'+Math.random().toString(36).slice(2));
 sessionStorage.setItem(TB_BUILDER_SESSION_KEY,tbBuilderSessionId);
}
let tbDesignSignature='';
let tbDesignId='';
const tbCompletedDesigns=new Set();
function tbDevice(){return window.matchMedia('(max-width:760px)').matches?'mobile':'desktop'}
function tbCustomerId(){
 const candidates=[
  window.ShopifyAnalytics?.meta?.page?.customerId,
  window.meta?.page?.customerId,
  window.__st?.cid
 ];
 for(const value of candidates){
  const id=String(value||'').replace('gid://shopify/Customer/','').trim();
  if(/^\d+$/.test(id))return id;
 }
 return null;
}
function tbDesignIdentity(){
 const signature=enc(payload());
 if(signature!==tbDesignSignature){
  tbDesignSignature=signature;
  tbDesignId='tbd_'+(crypto.randomUUID?crypto.randomUUID():Date.now()+'_'+Math.random().toString(36).slice(2));
 }
 return tbDesignId;
}
function tbTrackingContext(extra={}){
 const braceletV=state.braceletVariant;
 const claspV=activeVariant(state.clasp);
 const beadSkus=state.beads.map(b=>activeVariant(b.product)?.sku).filter(Boolean);
 return Object.assign({
  session_id:tbBuilderSessionId,
  design_id:hasDesign()?tbDesignIdentity():null,
  customer_id:tbCustomerId(),
  device:tbDevice(),
  source:new URL(location.href).searchParams.get('tb_shared')==='1'?'shared_design':'builder',
  design_value_pence:total(),
  bead_count:state.beads.length,
  bracelet_sku:braceletV?.sku||null,
  bracelet_size:braceletV?.title||null,
  clasp_sku:claspV?.sku||null,
  bead_skus:beadSkus
 },extra);
}
function trackBuilderEvent(eventName,extra={}){
 const body=Object.assign({
  event_id:'tbbe_'+(crypto.randomUUID?crypto.randomUUID():Date.now()+'_'+Math.random().toString(36).slice(2)),
  event_name:eventName,
  page_url:location.href,
  referrer:document.referrer||null
 },tbTrackingContext(extra));
 try{
  fetch(TB_BUILDER_TRACK_ENDPOINT,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body),keepalive:true,credentials:'omit'}).catch(()=>{});
 }catch{}
 try{
  if(typeof window.gtag==='function')window.gtag('event',eventName,{
   builder_session_id:body.session_id,design_id:body.design_id,design_value:body.design_value_pence/100,
   bead_count:body.bead_count,bracelet_sku:body.bracelet_sku,clasp_sku:body.clasp_sku,builder_source:body.source
  });
 }catch{}
}
function trackDesignCompletedOnce(){
 if(!(state.bracelet&&state.clasp&&state.beads.length))return;
 const signature=enc(payload());
 if(tbCompletedDesigns.has(signature))return;
 tbCompletedDesigns.add(signature);
 trackBuilderEvent('bracelet_design_completed');
}

const mobileClaspLocator=false;
const MOBILE_CLASP_KEY='tb_mobile_clasp_position_v1';
let mobileClaspPanel=null,mobileClaspDrag=null;

function getMobileClaspPos(){
 try{return JSON.parse(localStorage.getItem(MOBILE_CLASP_KEY)||'null')}catch{return null}
}
function setMobileClaspPos(pos){
 localStorage.setItem(MOBILE_CLASP_KEY,JSON.stringify(pos));
 updateMobileClaspPanel();
}
function currentMobileClaspPos(){
 const visual=$('.tb-builder__visual');
 if(!visual||!state.bracelet||!state.clasp)return null;
 const vr=visual.getBoundingClientRect(),br=braceletImg.getBoundingClientRect(),cr=claspImg.getBoundingClientRect();
 return {dx:Math.round((cr.left-vr.left)-(br.left-vr.left)),dy:Math.round((cr.top-vr.top)-(br.top-vr.top))};
}
function ensureMobileClaspPanel(){
 if(!mobileClaspLocator||mobileClaspPanel||!window.matchMedia('(max-width:760px)').matches)return;
 mobileClaspPanel=document.createElement('div');
 mobileClaspPanel.innerHTML=`
  <strong style="display:block;margin-bottom:5px">Mobile clasp locator</strong>
  <div style="display:flex;gap:6px;align-items:center">
   <label>X <input data-mcx type="number" style="width:58px"></label>
   <label>Y <input data-mcy type="number" style="width:58px"></label>
   <button type="button" data-mcapply>Apply</button>
  </div>
  <div style="display:flex;gap:5px;margin-top:6px">
   <button type="button" data-mcl>←</button>
   <button type="button" data-mcr>→</button>
   <button type="button" data-mcu>↑</button>
   <button type="button" data-mcd>↓</button>
   <button type="button" data-mccopy>Copy</button>
  </div>
  <small style="display:block;margin-top:5px">Drag clasp, then fine-tune. Coordinates are relative to bracelet.</small>`;
 Object.assign(mobileClaspPanel.style,{
  position:'fixed',left:'10px',right:'10px',bottom:'10px',zIndex:'999999',
  background:'#fff',border:'1px solid #111',padding:'9px',font:'12px Arial,sans-serif',
  boxShadow:'0 3px 14px rgba(0,0,0,.2)'
 });
 document.body.appendChild(mobileClaspPanel);
 const q=s=>mobileClaspPanel.querySelector(s);
 const apply=()=>{
  const dx=Number(q('[data-mcx]').value),dy=Number(q('[data-mcy]').value);
  if(Number.isFinite(dx)&&Number.isFinite(dy)){setMobileClaspPos({dx,dy});renderStage()}
 };
 q('[data-mcapply]').onclick=apply;
 const bump=(x,y)=>{
  const p=currentMobileClaspPos();if(!p)return;
  setMobileClaspPos({dx:p.dx+x,dy:p.dy+y});renderStage();
 };
 q('[data-mcl]').onclick=()=>bump(-1,0);
 q('[data-mcr]').onclick=()=>bump(1,0);
 q('[data-mcu]').onclick=()=>bump(0,-1);
 q('[data-mcd]').onclick=()=>bump(0,1);
 q('[data-mccopy]').onclick=async()=>{
  const p=currentMobileClaspPos();if(!p)return;
  const text=JSON.stringify(p);
  try{await navigator.clipboard.writeText(text);q('[data-mccopy]').textContent='Copied ✓'}
  catch{prompt('Copy mobile clasp coordinates:',text)}
 };
 updateMobileClaspPanel();
}
function updateMobileClaspPanel(){
 if(!mobileClaspPanel)return;
 const p=currentMobileClaspPos();if(!p)return;
 mobileClaspPanel.querySelector('[data-mcx]').value=p.dx;
 mobileClaspPanel.querySelector('[data-mcy]').value=p.dy;
}
function enableMobileClaspDrag(){
 if(!mobileClaspLocator||!window.matchMedia('(max-width:760px)').matches||!state.bracelet||!state.clasp)return;
 claspImg.style.setProperty('pointer-events','auto','important');
 claspImg.style.setProperty('cursor','move','important');
 claspImg.onpointerdown=e=>{
  e.preventDefault();
  const cr=claspImg.getBoundingClientRect();
  mobileClaspDrag={id:e.pointerId,offX:e.clientX-cr.left,offY:e.clientY-cr.top};
  try{claspImg.setPointerCapture(e.pointerId)}catch{}
 };
 claspImg.onpointermove=e=>{
  if(!mobileClaspDrag||e.pointerId!==mobileClaspDrag.id)return;
  const visual=$('.tb-builder__visual'),vr=visual.getBoundingClientRect(),br=braceletImg.getBoundingClientRect();
  const left=e.clientX-vr.left-mobileClaspDrag.offX;
  const top=e.clientY-vr.top-mobileClaspDrag.offY;
  claspImg.style.setProperty('left',left+'px','important');
  claspImg.style.setProperty('top',top+'px','important');
  setMobileClaspPos({
   dx:Math.round(left-(br.left-vr.left)),
   dy:Math.round(top-(br.top-vr.top))
  });
 };
 const end=e=>{if(mobileClaspDrag&&e.pointerId===mobileClaspDrag.id){mobileClaspDrag=null;updateMobileClaspPanel()}};
 claspImg.onpointerup=end;claspImg.onpointercancel=end;
}


const money=c=>moneyFormat.replace(/\{\{\s*amount(?:_no_decimals)?\s*\}\}/,(Number(c||0)/100).toFixed(2).replace('.00',''));
const activeVariant=p=>p?.variants?.find(v=>v.available)||p?.variants?.[0]||null;
const skuOf=(p,v)=>v?.sku||activeVariant(p)?.sku||'';
const asset=(p,v)=>{
 const sku=skuOf(p,v);
 if(builderAssets[sku]) return builderAssets[sku];
 // One approved Sterling Silver Foxtail artwork currently represents every silver size.
 if(/^TAGBR-000(02|03|04|05|08|09|10|11|12|13|14)$/.test(sku)) return builderAssets['TAGBR-00009']||'';
 return '';
};
const tags=p=>(p.tags||[]).map(x=>String(x).toLowerCase());
const material=p=>{
 const t=(p.title+' '+p.type+' '+(p.tags||[]).join(' ')).toLowerCase();
 if(t.includes('glass')||t.includes('murano'))return'glass';
 if(t.includes('gemstone')||t.includes('gem ')||t.includes('stone'))return'gemstone';
 if(t.includes('gold'))return'gold';
 if(t.includes('silver'))return'silver';
 return'other';
};
const isNew=p=>tags(p).some(t=>t==='new'||t.includes('new collection')||t.includes('new season'));
const total=()=>[
 state.bracelet?{p:state.bracelet,v:state.braceletVariant}:null,
 state.clasp?{p:state.clasp,v:activeVariant(state.clasp)}:null,
 ...state.beads.map(b=>({p:b.product,v:activeVariant(b.product)}))
].filter(Boolean).reduce((n,x)=>n+Number(x.v?.price||0),0);

function usedCount(p){return state.beads.filter(b=>b.product.id===p.id).length}
function cartItems(){
 const m=new Map();
 const rows=[
  state.bracelet?state.braceletVariant:null,
  state.clasp?activeVariant(state.clasp):null,
  ...state.beads.map(b=>activeVariant(b.product))
 ].filter(Boolean);
 const designId=hasDesign()?tbDesignIdentity():null;
 const source=new URL(location.href).searchParams.get('tb_shared')==='1'?'shared_design':'builder';
 rows.forEach(v=>{
  const id=String(v.id);
  if(!m.has(id))m.set(id,{id:Number(id),quantity:0,properties:{
   _tb_builder_design_id:designId,
   _tb_builder_session_id:tbBuilderSessionId,
   _tb_builder_source:source,
   _tb_builder_value_pence:String(total()),
   _tb_builder_bead_count:String(state.beads.length)
  }});
  m.get(id).quantity++;
 });
 return[...m.values()]
}
function productBySku(s){return products.find(p=>p.variants.some(v=>v.sku===s))||null}
function variantBySku(p,s){return p?.variants?.find(v=>v.sku===s)||null}

function payload(){return{v:1,b:state.braceletVariant?.sku||null,c:activeVariant(state.clasp)?.sku||null,d:state.beads.map(b=>[activeVariant(b.product)?.sku,Math.round(b.x*10)/10])}}
function enc(o){const a=new TextEncoder().encode(JSON.stringify(o));let s='';a.forEach(b=>s+=String.fromCharCode(b));return btoa(s).replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,'')}
function dec(s){try{const x=s.replace(/-/g,'+').replace(/_/g,'/'),b=atob(x+'='.repeat((4-x.length%4)%4));return JSON.parse(new TextDecoder().decode(Uint8Array.from(b,c=>c.charCodeAt(0))))}catch{return null}}
function syncUrl(){if(!(state.bracelet||state.clasp||state.beads.length))return;const u=new URL(location.href);u.searchParams.set('design',enc(payload()));history.replaceState(null,'',u)}
function restore(){
 const q=new URL(location.href).searchParams.get('design');if(!q)return;
 const o=dec(q);if(!o||o.v!==1)return;
 if(o.b){const p=productBySku(o.b),v=variantBySku(p,o.b);if(p&&v){state.bracelet=p;state.braceletVariant=v}}
 if(o.c){const p=productBySku(o.c);if(p)state.clasp=p}
 if(Array.isArray(o.d))o.d.forEach(([s,x])=>{const p=productBySku(s);if(p)state.beads.push({product:p,uid:'b'+(++uid),x:Math.max(2,Math.min(98,Number(x)||7))})});
 state.step=state.clasp?'beads':state.bracelet?'clasp':'bracelet';
 const u=new URL(location.href),sharedId=u.searchParams.get('tb_design_id');
 if(sharedId){tbDesignSignature=enc(payload());tbDesignId=sharedId}
}

function beadHalf(i){const b=state.beads[i],base={'TAGBE-00314':65,'TSTBE-20017':70,'TAGBE-10279':67}[activeVariant(b.product)?.sku]||67,w=window.matchMedia('(max-width:760px)').matches?base*.445:base;return(w/Math.max(rail.clientWidth,1)*100)/2}
function collide(i,x,dir=1){
 const h=beadHalf(i),min=2+h,max=98-h; x=Math.max(min,Math.min(max,x));
 const os=state.beads.map((b,j)=>({j,x:b.x,h:beadHalf(j)})).filter(o=>o.j!==i).sort((a,b)=>a.x-b.x);
 for(let pass=0;pass<os.length+3;pass++){const hit=os.find(o=>Math.abs(x-o.x)<h+o.h+.45);if(!hit)break;const g=h+hit.h+.45,l=hit.x-g,r=hit.x+g,lv=l>=min,rv=r<=max;if(lv&&rv)x=Math.abs(x-l)<Math.abs(r-x)?l:r;else if(lv)x=l;else if(rv)x=r;else break}
 return Math.max(min,Math.min(max,x))
}

function selectProduct(p){
 if(p.kind==='bracelet'){
  state.bracelet=p;state.braceletVariant=activeVariant(p);state.step='clasp';state.page=1;
 }
 else if(p.kind==='clasp'){
  state.clasp=p;state.step='beads';state.page=1;
  trackBuilderEvent('clasp_selected',{product_id:String(p.id),product_title:p.title,variant_id:String(activeVariant(p)?.id||'')});
 }
 else{
  /* Keep the current catalogue page depth when adding beads.
     If the customer has clicked Show more, the expanded results stay open. */
  const b={product:p,uid:'b'+(++uid),x:7};
  state.beads.push(b);
  const i=state.beads.length-1,before=state.beads.slice(0,-1);
  b.x=collide(i,before.length?Math.min(94,Math.max(...before.map(x=>x.x))+7):7,1);
  state.selected=b.uid;
  trackBuilderEvent('bead_added',{product_id:String(p.id),product_title:p.title,variant_id:String(activeVariant(p)?.id||''),bead_sku:activeVariant(p)?.sku||null});
 }
 render()
}

function renderStage(){
 const ba=asset(state.bracelet,state.braceletVariant),ca=asset(state.clasp,activeVariant(state.clasp));
 if(state.bracelet&&ba){
  braceletImg.src=ba;braceletImg.hidden=false;braceletImg.style.removeProperty('display');
 }else{
  braceletImg.removeAttribute('src');braceletImg.hidden=true;
  braceletImg.style.setProperty('display','none','important');
 }
 if(state.clasp&&ca){
  claspImg.src=ca;claspImg.hidden=false;claspImg.style.removeProperty('display');
 }else{
  claspImg.removeAttribute('src');claspImg.hidden=true;
  claspImg.style.setProperty('display','none','important');
 }

 // SHOPIFY CLASP ANCHOR.
 // Do NOT move or resize the bracelet. Position the approved clasp against the
 // bracelet's rendered left endpoint, so the relationship survives responsive widths.
 const visual=$('.tb-builder__visual');
 if(claspImg.parentElement!==visual) visual.appendChild(claspImg);
 if(state.clasp&&ca&&state.bracelet&&ba){
  requestAnimationFrame(()=>{
   const vr=visual.getBoundingClientRect();
   const br=braceletImg.getBoundingClientRect();

   // Desktop geometry remains locked. Mobile gets its own scaled composition.
   const mobile=window.matchMedia('(max-width:760px)').matches;
   const claspW=mobile?108:245;
   const claspH=mobile?86:194;

   // Desktop remains exactly X -138 / Y -14.
   // Mobile uses the proportional equivalent against the same bracelet artwork.
   const mobileDx=-61;
   const mobileDy=-18;
   const left=(br.left-vr.left)+(mobile?mobileDx:-138);
   const top=(br.top-vr.top)+(mobile?mobileDy:-14);

   claspImg.style.setProperty('position','absolute','important');
   claspImg.style.setProperty('width',claspW+'px','important');
   claspImg.style.setProperty('height',claspH+'px','important');
   claspImg.style.setProperty('left',left+'px','important');
   claspImg.style.setProperty('top',top+'px','important');
   claspImg.style.setProperty('transform','none','important');
   claspImg.style.setProperty('pointer-events',(mobile&&mobileClaspLocator)?'auto':'none','important');
   claspImg.style.setProperty('z-index','8','important');
   if(mobile&&mobileClaspLocator){ensureMobileClaspPanel();enableMobileClaspDrag();requestAnimationFrame(updateMobileClaspPanel)}
  });
 }else{
  claspImg.style.removeProperty('position');
  claspImg.style.removeProperty('width');
  claspImg.style.removeProperty('height');
  claspImg.style.removeProperty('left');
  claspImg.style.removeProperty('top');
  claspImg.style.removeProperty('transform');
  claspImg.style.removeProperty('pointer-events');
  claspImg.style.removeProperty('z-index');
 }
 rail.innerHTML=state.beads.map((b,i)=>{const a=asset(b.product,activeVariant(b.product));return a?`<button class="tb-dragbead ${state.selected===b.uid?'is-selected':''}" data-i="${i}" style="left:${b.x}%" aria-label="${b.product.title}"><img src="${a}" alt=""></button>`:''}).join('');
 rail.querySelectorAll('.tb-dragbead').forEach(el=>{
  el.ondragstart=e=>e.preventDefault();
  el.onpointerdown=startDrag;
  el.onclick=()=>{
    state.selected=state.beads[+el.dataset.i].uid;
    renderSelection();
    if(window.matchMedia('(max-width:760px)').matches){try{el.blur()}catch{}}
  };
 });
 const n=$('#tb-stage-note');
 if(!state.bracelet)n.textContent='Choose a bracelet to begin';
 else if(!ba)n.textContent='Choose another bracelet';
 else if(!state.clasp)n.textContent='Now choose a clasp';
 else if(!ca)n.textContent='Choose another clasp';
 else n.textContent=state.beads.length?'':'Now add your beads';
}
function renderSelection(){
 const box=$('#tb-selection'),i=state.beads.findIndex(b=>b.uid===state.selected);
 if(i<0){box.hidden=true;return}const b=state.beads[i];box.hidden=false;
 box.innerHTML=`<strong>${b.product.title}</strong><span>${money(activeVariant(b.product)?.price)}</span><button data-n="-1.5">←</button><button data-n="1.5">→</button><button data-dup>Duplicate</button><button data-rm>Remove</button>`;
 box.querySelectorAll('[data-n]').forEach(x=>x.onclick=()=>{const d=+x.dataset.n;b.x=collide(i,b.x+d,d);render()});
 box.querySelector('[data-dup]').onclick=()=>{const c={product:b.product,uid:'b'+(++uid),x:b.x};state.beads.push(c);c.x=collide(state.beads.length-1,b.x+7,1);state.selected=c.uid;render()};
 box.querySelector('[data-rm]').onclick=()=>{state.beads.splice(i,1);state.selected=null;render()}
}
function startDrag(e){e.preventDefault();const i=+e.currentTarget.dataset.i;state.selected=state.beads[i].uid;state.drag={i,el:e.currentTarget,id:e.pointerId,last:e.clientX};e.currentTarget.classList.add('is-dragging');try{e.currentTarget.setPointerCapture(e.pointerId)}catch{}renderSelection()}
function move(e){const d=state.drag;if(!d||e.pointerId!==d.id)return;const r=rail.getBoundingClientRect(),raw=(e.clientX-r.left)/r.width*100,dir=e.clientX-d.last,x=collide(d.i,raw,dir);state.beads[d.i].x=x;d.last=e.clientX;d.el.style.left=x+'%';e.preventDefault()}
function end(e){const d=state.drag;if(!d||(e?.pointerId!==undefined&&e.pointerId!==d.id))return;d.el.classList.remove('is-dragging');state.drag=null;syncUrl()}
addEventListener('pointermove',move,{passive:false});addEventListener('pointerup',end);addEventListener('pointercancel',end);

function filtered(){
 let a=products.filter(p=>p.kind===(state.step==='beads'?'bead':state.step));
 if(state.step==='beads'){
  if(state.filter==='design')a=a.filter(p=>usedCount(p)>0);
  else if(state.filter==='new')a=a.filter(isNew);
  else if(state.filter!=='all')a=a.filter(p=>material(p)===state.filter);
 }
 if(state.query){const q=state.query.toLowerCase();a=a.filter(p=>(p.title+' '+p.variants.map(v=>v.sku).join(' ')).toLowerCase().includes(q))}
 if(state.sort==='az')a.sort((a,b)=>a.title.localeCompare(b.title));
 else if(state.sort==='price-low')a.sort((a,b)=>(activeVariant(a)?.price||0)-(activeVariant(b)?.price||0));
 else if(state.sort==='price-high')a.sort((a,b)=>(activeVariant(b)?.price||0)-(activeVariant(a)?.price||0));
 else a.sort((a,b)=>Number(anyAvailable(b))-Number(anyAvailable(a)));
 return a
}
const anyAvailable=p=>p.variants.some(v=>v.available);
function renderCatalogue(){
 const all=filtered(),pages=Math.max(1,Math.ceil(all.length/state.perPage));state.page=Math.min(state.page,pages);
 const rows=all.slice(0,state.page*state.perPage);
 $('#tb-results').textContent=`${all.length.toLocaleString()} ${state.step==='beads'?'products':state.step+(all.length===1?'':'s')}`;
 $('#tb-grid').innerHTML=rows.map(p=>{const v=activeVariant(p),used=usedCount(p),a=asset(p,v),available=anyAvailable(p);
 return`<article class="tb-product ${used?'is-used':''}">
 <div class="tb-product__image">${p.image?`<img src="${p.image}" alt="" loading="lazy">`:''}${used?`<span class="tb-used">${used} in design</span>`:''}</div>
 <div class="tb-product__meta">${v?.sku||''}${a?' · Builder ready':''}</div><h3>${p.title}</h3>
 ${p.kind==='bracelet'?`<p class="tb-bracelet-from">From ${money(Math.min(...p.variants.filter(x=>x.available).map(x=>x.price)))}</p>`:`<p>${money(v?.price||0)}</p>`}
 <button data-add="${p.id}" ${available?'':'disabled'}>${available?(used&&p.kind==='bead'?'Add another':'Add to design'):'Sold out'}</button></article>`}).join('')||'<div class="tb-empty"><strong>No matches</strong><span>Try another search or filter.</span></div>';
 $('#tb-load-more').hidden=rows.length>=all.length;$('#tb-load-more').textContent=`Show more (${Math.min(state.perPage,all.length-rows.length)} more)`;
}
function renderSummary(){
 const box=$('#tb-design-summary');
 const rows=[];
 if(state.bracelet)rows.push([state.bracelet.title+' · '+state.braceletVariant.title,money(state.braceletVariant.price)]);
 if(state.clasp)rows.push([state.clasp.title,money(activeVariant(state.clasp).price)]);
 const grouped=new Map();state.beads.forEach(b=>{const k=b.product.id;if(!grouped.has(k))grouped.set(k,{p:b.product,n:0});grouped.get(k).n++});
 grouped.forEach(x=>rows.push([`${x.p.title}${x.n>1?' × '+x.n:''}`,money(activeVariant(x.p).price*x.n)]));
 box.innerHTML=rows.length?rows.map(r=>`<div><span>${r[0]}</span><strong>${r[1]}</strong></div>`).join(''):'<p>Your selected bracelet, clasp and beads will appear here.</p>';
}
function render(){
 root.classList.toggle('tb-builder--picker',state.step==='clasp'||state.step==='beads');
 root.dataset.currentStep=state.step;
 if(typeof updateSaveButtons==='function')updateSaveButtons();
 $$('.tb-builder__tabs button').forEach(b=>b.setAttribute('aria-selected',String(b.dataset.step===state.step)));
 const stepLabel=root.querySelector('[data-step-label]');
 if(stepLabel)stepLabel.textContent=state.step==='beads'?'beads':state.step;
 const beadText=`${state.beads.length} bead${state.beads.length===1?'':'s'}`;
 $('#tb-total').textContent=money(total());$('#tb-count').textContent=beadText;
 const footerCount=$('#tb-count-footer'),footerTotal=$('#tb-footer-total');
 if(footerCount)footerCount.textContent=state.bracelet?`Your bracelet · ${beadText}`:'Your bracelet';
 if(footerTotal)footerTotal.textContent=money(total());
 $('#tb-add-cart').disabled=!(state.bracelet&&state.clasp);renderStage();renderSelection();renderCatalogue();renderSummary();syncUrl();trackDesignCompletedOnce()
}


function closeBraceletSizeModal(){
 const modal=document.getElementById('tb-bracelet-size-modal');
 if(modal)modal.remove();
 document.body.classList.remove('tb-size-open');
}
function openBraceletSizeModal(product){
 closeBraceletSizeModal();
 const variants=product.variants.filter(v=>v.available);
 if(!variants.length)return;

 const modal=document.createElement('div');
 modal.id='tb-bracelet-size-modal';
 modal.className='tb-size-modal';
 modal.innerHTML=`
  <div class="tb-size-modal__backdrop" data-size-close></div>
  <div class="tb-size-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="tb-size-title">
   <button type="button" class="tb-size-modal__close" data-size-close aria-label="Close">×</button>
   <p class="tb-size-modal__eyebrow">Your Trollbeads bracelet</p>
   <h2 id="tb-size-title">Choose your bracelet size</h2>
   <p class="tb-size-modal__intro">Select the bracelet length you'd like to use for your design.</p>
   <div class="tb-size-modal__product">
    ${product.image?`<img src="${product.image}" alt="">`:''}
    <div><strong>${product.title}</strong><span>Choose from the available sizes below.</span></div>
   </div>
   <div class="tb-size-modal__sizes">
    ${variants.map(v=>`<button type="button" data-size-variant="${v.id}"><strong>${v.title}</strong><span>${money(v.price)}</span></button>`).join('')}
   </div>
  </div>`;

 document.body.appendChild(modal);
 document.body.classList.add('tb-size-open');
 modal.querySelectorAll('[data-size-close]').forEach(b=>b.onclick=closeBraceletSizeModal);
 modal.querySelectorAll('[data-size-variant]').forEach(b=>b.onclick=()=>{
  const v=product.variants.find(x=>String(x.id)===String(b.dataset.sizeVariant));
  if(!v)return;
  state.bracelet=product;
  state.braceletVariant=v;
  state.step='clasp';
  state.page=1;
  closeBraceletSizeModal();
  trackBuilderEvent('bracelet_selected',{product_id:String(product.id),product_title:product.title,variant_id:String(v.id),bracelet_sku:v.sku||null,bracelet_size:v.title||null});
  render();
 });
 modal.addEventListener('keydown',e=>{if(e.key==='Escape')closeBraceletSizeModal()});
 setTimeout(()=>modal.querySelector('[data-size-variant]')?.focus(),30);
}

// Delegated catalogue click handler: resilient to theme/app DOM re-rendering.
root.addEventListener('click',e=>{
 const btn=e.target.closest('[data-add]');
 if(!btn||!root.contains(btn)) return;
 e.preventDefault();
 const p=products.find(x=>x.id===btn.dataset.add);
 if(!p) return;
 if(p.kind==='bracelet'){
  openBraceletSizeModal(p);
 }else{
  selectProduct(p);
 }
});
$$('.tb-builder__tabs button').forEach(b=>b.onclick=()=>{state.step=b.dataset.step;state.page=1;render()});
$('#tb-search').oninput=e=>{state.query=e.target.value.trim();state.page=1;renderCatalogue()};
$$('[data-filter]').forEach(b=>b.onclick=()=>{state.filter=b.dataset.filter;state.page=1;$$('[data-filter]').forEach(x=>x.classList.toggle('is-active',x===b));renderCatalogue()});
$('#tb-sort').onchange=e=>{state.sort=e.target.value;renderCatalogue()};
$('#tb-load-more').onclick=()=>{state.page++;renderCatalogue()};
$('#tb-summary-toggle').onclick=()=>{$('#tb-summary-panel').classList.toggle('is-open')};


/* ---------- Share / gifting experience ---------- */
const TB_SAVED_DESIGN_KEY='tb_saved_bracelet_design_v1';

function designUrl(){
 const u=new URL(location.href);
 u.searchParams.set('design',enc(payload()));
 u.searchParams.set('tb_shared','1');
 u.searchParams.set('tb_design_id',tbDesignIdentity());
 return u.toString();
}
function hasDesign(){
 return !!(state.bracelet||state.clasp||state.beads.length);
}
function savedDesign(){
 try{return JSON.parse(localStorage.getItem(TB_SAVED_DESIGN_KEY)||'null')}catch{return null}
}
function isCurrentDesignSaved(){
 const s=savedDesign();
 return !!(s&&s.design===enc(payload()));
}
function updateSaveButtons(){
 const saved=isCurrentDesignSaved();
 document.querySelectorAll('[data-tb-save-design]').forEach(b=>{
  b.textContent=saved?'♥ Saved':'♡ Save my design';
  b.setAttribute('aria-pressed',String(saved));
 });
}
function wishlistDesignItems(){
 const rows=[];
 if(state.bracelet&&state.braceletVariant)rows.push({product:state.bracelet,variant:state.braceletVariant});
 if(state.clasp){
  const v=activeVariant(state.clasp);
  if(v)rows.push({product:state.clasp,variant:v});
 }
 state.beads.forEach(b=>{
  const v=activeVariant(b.product);
  if(v)rows.push({product:b.product,variant:v});
 });
 const unique=new Map();
 rows.forEach(row=>{
  const key=String(row.variant.id);
  if(!unique.has(key))unique.set(key,row);
 });
 return [...unique.values()];
}
function updateWishlistSaveCopy(count){
 document.querySelectorAll('[data-tb-save-design]').forEach(b=>{
  b.textContent='♥ Saved to Wishlist';
  b.setAttribute('aria-pressed','true');
 });
 const note=document.querySelector('.tb-share-modal__save small');
 if(note)note.innerHTML=`All ${count} ${count===1?'piece':'pieces'} from your bracelet ${count===1?'has':'have'} been saved. <a href="/a/wishlist">View my Wishlist →</a>`;
}
async function saveCurrentDesign(){
 if(!hasDesign())return;
 const items=wishlistDesignItems();
 if(!items.length)return;

 /* Keep exact composition locally; Smart Wishlist stores the real Shopify components. */
 const record={design:enc(payload()),url:designUrl(),savedAt:new Date().toISOString()};
 localStorage.setItem(TB_SAVED_DESIGN_KEY,JSON.stringify(record));

 if(typeof window.AddToSmartWishlist!=='function'){
  updateSaveButtons();
  const note=document.querySelector('.tb-share-modal__save small');
  if(note)note.textContent='Your design has been saved on this device. Wishlist is still loading — please try again in a moment.';
  return;
 }

 const buttons=[...document.querySelectorAll('[data-tb-save-design]')];
 buttons.forEach(b=>{b.disabled=true;b.textContent='Saving…'});

 try{
  items.forEach(({product,variant})=>{
   window.AddToSmartWishlist(Number(product.id),Number(variant.id));
  });
  updateWishlistSaveCopy(items.length);
  trackBuilderEvent('bracelet_design_wishlisted',{wishlist_item_count:items.length});
 }catch(e){
  console.error('Smart Wishlist save failed',e);
  updateSaveButtons();
  const note=document.querySelector('.tb-share-modal__save small');
  if(note)note.textContent='We saved your design on this device, but could not add the pieces to your Wishlist. Please try again.';
 }finally{
  buttons.forEach(b=>b.disabled=false);
 }
}
async function copyDesignLink(button){
 const url=designUrl();
 try{
  await navigator.clipboard.writeText(url);
  trackBuilderEvent('bracelet_design_link_copied');
  if(button){
   const title=button.querySelector('.tb-share-choice__content strong');
   if(title){
    const old=title.textContent;
    title.textContent='Copied ✓';
    setTimeout(()=>title.textContent=old,1400);
   }
  }
 }catch{prompt('Copy your bracelet link:',url)}
}
async function nativeDesignShare(kind){
 const url=designUrl();
 const hint=kind==='hint';
 const message=hint
  ?"I've designed a Trollbeads bracelet I love… just leaving this here 👀 Click the link to view my design."
  :"I've designed a Trollbeads bracelet. Click the link to view my design.";
 const data={
  title:hint?'A little Trollbeads hint…':'My Trollbeads bracelet',
  text:message,
  url:url
 };
 try{
  /* Keep URL in the dedicated Web Share field so the operating system
     recognises this as a link share and exposes installed social/share targets. */
  if(navigator.share){await navigator.share(data);trackBuilderEvent(hint?'bracelet_hint_sent':'bracelet_design_shared')} 
  else{
   const shareText=message+'\n\n'+url;
   try{await navigator.clipboard.writeText(shareText);trackBuilderEvent(hint?'bracelet_hint_sent':'bracelet_design_shared',{share_method:'clipboard'});alert('Message and design link copied ✓')}
   catch{prompt('Copy and share this:',shareText)}
  }
 }catch(e){
  if(e.name!=='AbortError')prompt('Copy and share this:',message+'\n\n'+url)
 }
}
function closeShareModal(){
 const modal=document.getElementById('tb-share-modal');
 if(modal){modal.classList.remove('is-open');document.body.classList.remove('tb-share-open')}
}
function ensureShareModal(){
 let modal=document.getElementById('tb-share-modal');
 if(modal)return modal;
 modal=document.createElement('div');
 modal.id='tb-share-modal';
 modal.className='tb-share-modal';
 modal.setAttribute('aria-hidden','true');
 modal.innerHTML=`
  <div class="tb-share-modal__backdrop" data-share-close></div>
  <div class="tb-share-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="tb-share-title">
   <button class="tb-share-modal__close" type="button" aria-label="Close" data-share-close>×</button>
   <p class="tb-share-modal__eyebrow">Your Trollbeads bracelet</p>
   <h2 id="tb-share-title">Share your design</h2>
   <p class="tb-share-modal__intro">Found your perfect combination? Save it for later, share it with someone special, or send a not-so-subtle hint.</p>

   <div class="tb-share-modal__choices">
    <button type="button" class="tb-share-choice tb-share-choice--hint" data-share-hint>
     <span class="tb-share-choice__icon">♡</span>
     <span class="tb-share-choice__content"><strong>Send a hint</strong><small>Spotted something you'd love? Send your bracelet to someone who might need a little inspiration.</small></span>
     <span class="tb-share-choice__arrow">→</span>
    </button>

    <button type="button" class="tb-share-choice" data-share-friend>
     <span class="tb-share-choice__icon">↗</span>
     <span class="tb-share-choice__content"><strong>Share with someone</strong><small>Share your design with a friend, partner or family member.</small></span>
     <span class="tb-share-choice__arrow">→</span>
    </button>

    <button type="button" class="tb-share-choice" data-share-copy>
     <span class="tb-share-choice__icon">⧉</span>
     <span class="tb-share-choice__content"><strong>Copy design link</strong><small>Keep your bracelet handy or send it however you like.</small></span>
     <span class="tb-share-choice__arrow">→</span>
    </button>
   </div>

   <div class="tb-share-modal__save">
    <button type="button" data-tb-save-design>♡ Save my design</button>
    <small>Your saved design stays on this device so you can come back to it later.</small>
   </div>
  </div>`;
 document.body.appendChild(modal);

 modal.querySelectorAll('[data-share-close]').forEach(x=>x.onclick=closeShareModal);
 modal.querySelector('[data-share-hint]').onclick=()=>nativeDesignShare('hint');
 modal.querySelector('[data-share-friend]').onclick=()=>nativeDesignShare('friend');
 modal.querySelector('[data-share-copy]').onclick=e=>copyDesignLink(e.currentTarget);
 modal.querySelector('[data-tb-save-design]').onclick=saveCurrentDesign;
 modal.addEventListener('keydown',e=>{if(e.key==='Escape')closeShareModal()});
 updateSaveButtons();
 return modal;
}
function openShareModal(){
 if(!hasDesign())return;
 const modal=ensureShareModal();
 modal.classList.add('is-open');
 modal.setAttribute('aria-hidden','false');
 document.body.classList.add('tb-share-open');
 updateSaveButtons();
 setTimeout(()=>modal.querySelector('[data-share-hint]')?.focus(),30);
}

/* Promote sharing + saving in the main builder actions. */
$('#tb-share').textContent='Share your design';
$('#tb-share').onclick=openShareModal;

const topActions=$('.tb-builder__share-actions');
if(topActions&&!topActions.querySelector('[data-tb-save-design]')){
 const save=document.createElement('button');
 save.type='button';
 save.className='tb-save-design';
 save.setAttribute('data-tb-save-design','');
 save.onclick=saveCurrentDesign;
 topActions.insertBefore(save,$('#tb-new-design'));
}
updateSaveButtons();

$('#tb-new-design').onclick=()=>{Object.assign(state,{step:'bracelet',bracelet:null,braceletVariant:null,clasp:null,beads:[],selected:null,page:1});const u=new URL(location.href);u.searchParams.delete('design');history.replaceState(null,'',u);render()};

$('#tb-add-cart').onclick=async()=>{
 const b=$('#tb-add-cart'),old=b.textContent,items=cartItems();
 if(!items.length)return;
 b.disabled=true;b.textContent='Adding…';
 try{
  const shopRoot=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
  const r=await fetch(shopRoot+'cart/add.js',{
   method:'POST',
   headers:{'Content-Type':'application/json','Accept':'application/json'},
   body:JSON.stringify({items})
  });
  const d=await r.json();
  if(!r.ok)throw Error(d.description||d.message||'Could not add design');

  // Confirm the cart session has updated before asking Motion to rebuild its drawer.
  const cr=await fetch(shopRoot+'cart.js',{headers:{'Accept':'application/json'},cache:'no-store'});
  const cart=await cr.json();
  if(!cr.ok)throw Error('The design was added, but the bag could not be refreshed.');

  b.textContent='Added to bag ✓';
  trackBuilderEvent('bracelet_builder_add_to_cart',{cart_item_count:items.reduce((n,x)=>n+x.quantity,0)});

  // Motion 11 / Archetype documented cart refresh hook.
  document.dispatchEvent(new CustomEvent('cart:build'));
  document.dispatchEvent(new CustomEvent('ajaxProduct:added',{detail:{product:d,cart}}));

  // If this theme is configured for a cart page rather than a drawer, go there.
  setTimeout(()=>{
   const drawer=document.querySelector('.drawer--cart.is-open,.drawer--cart.drawer--is-open,#CartDrawer.is-open,[data-cart-drawer].is-open');
   if(!drawer && document.documentElement.classList.contains('js-drawer-open')===false){
    // Do not force navigation immediately: give Motion's cart:build handler time to open.
   }
  },500);
 }catch(e){
  console.error('[Trollbeads Builder] Add to bag failed:',e);
  b.textContent=e.message||'Could not add design';
 }finally{
  setTimeout(()=>{b.textContent=old;b.disabled=!(state.bracelet&&state.clasp)},2200)
 }
};


let tbMobileResizeTimer;
window.addEventListener('resize',()=>{
 clearTimeout(tbMobileResizeTimer);
 tbMobileResizeTimer=setTimeout(()=>{if(state.bracelet)renderStage()},120);
});
if(mobileClaspLocator)ensureMobileClaspPanel();
restore();render();
trackBuilderEvent('bracelet_builder_opened');
if(new URL(location.href).searchParams.get('tb_shared')==='1')trackBuilderEvent('bracelet_shared_design_opened',{shared_design_id:new URL(location.href).searchParams.get('tb_design_id')||null});
})();
